import React, { useState, useEffect } from "react"
import { Link, graphql } from "gatsby"
import Layout from "../components/layout"
import Seo from "../components/seo"
import * as styles from "../styles/sermon.module.scss"
import { FaArrowLeft, FaPlay } from "react-icons/fa"
import { GatsbyImage } from "gatsby-plugin-image"

const Series = ({ location, data }) => {
  const { seriesTitle, sermons, sermonSeriesGraphic } =
    data.contentfulSermonSeries
  const sortedMessagesSegment = sermons.sort(
    (a, b) => new Date(a.date) - new Date(b.date)
  )
  const [active, setActive] = useState({
    title: `${sortedMessagesSegment[0].sermonTitle}`,
    speaker: `${sortedMessagesSegment[0].preacher}`,
    details: `${sortedMessagesSegment[0].sermonDescription.sermonDescription}`,
    date: `${sortedMessagesSegment[0].date}`,
    embed: `${sortedMessagesSegment[0].youTubeLink}`,
    number: 1,
    locationIndex: location.state ? location.state.video : "",
  })
  const changeMessage = (e, index) => {
    e.preventDefault()
    const currentMessage = {
      title: `${sortedMessagesSegment[index].sermonTitle}`,
      speaker: `${sortedMessagesSegment[index].preacher}`,
      details: `${sortedMessagesSegment[index].sermonDescription.sermonDescription}`,
      date: `${sortedMessagesSegment[index].date}`,
      embed: `${sortedMessagesSegment[index].youTubeLink}`,
      number: `${index + 1}`,
    }
    setActive(currentMessage)
  }
  useEffect(() => {
    if (Number.isInteger(active.locationIndex)) {
      const currentMessage = {
        title: `${sortedMessagesSegment[active.locationIndex - 1].sermonTitle}`,
        speaker: `${sortedMessagesSegment[active.locationIndex - 1].preacher}`,
        details: `${
          sortedMessagesSegment[active.locationIndex - 1].sermonDescription
            .sermonDescription
        }`,
        date: `${sortedMessagesSegment[active.locationIndex - 1].date}`,
        embed: `${sortedMessagesSegment[active.locationIndex - 1].youTubeLink}`,
        number: `${active.locationIndex}`,
      }
      setActive(currentMessage)
    }
  }, [active.locationIndex, sortedMessagesSegment])
  const videoId = active.embed.split("?v=")[1]
  return (
    <React.Fragment>
      <Layout location={location.pathname}>
        <section className={styles.currentMessage}>
          <GatsbyImage
            image={sermonSeriesGraphic.gatsbyImageData}
            alt={sermonSeriesGraphic.description}
          />
          <div className="container">
            <div style={{ maxWidth: "1100px", margin: "auto" }}>
              <div className={styles.embedContainer}>
                <iframe
                  title={`First United Methodist Sermon - ${active.title}`}
                  src={`https://www.youtube.com/embed/${
                    videoId.indexOf("&") !== -1
                      ? videoId.substring(0, videoId.indexOf("&"))
                      : videoId
                  }`}
                  frameBorder="0"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </div>
        </section>
        <section className={styles.seriesDetails}>
          <div className="container">
            <h1 id="message-title">{seriesTitle}</h1>
            <div>
              <h2>
                Part {active.number} of {sermons.length}: {active.title}
              </h2>
              <div className={styles.messageDetails}>
                <h3>
                  {active.speaker} -{" "}
                  {new Date(active.date).toDateString().substring(4)}
                </h3>
                <p>{active.details}</p>
              </div>
            </div>
            <div className={styles.messagesInSeries}>
              <h2>Sermons in this Series</h2>
              <p className={styles.messageNum}>
                {active.number}/{sermons.length}
              </p>
              <div className={styles.messageParts}>
                {sortedMessagesSegment.map((edge, index) => (
                  <div key={index}>
                    <button onClick={e => changeMessage(e, index)}>
                      <p>
                        {index + 1 === Number(active.number) ? (
                          <FaPlay />
                        ) : (
                          index + 1
                        )}
                      </p>
                      <div>
                        <p>{edge.sermonTitle}</p>
                        <p>{edge.preacher}</p>
                      </div>
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
        <section className={styles.moreSermons}>
          <Link to="/sermons" className="back-link">
            <FaArrowLeft />
            Watch More Messages
          </Link>
        </section>
      </Layout>
    </React.Fragment>
  )
}

export default Series

export const pageQuery = graphql`
  query PageBySlug($slug: String!) {
    contentfulSermonSeries(slug: { eq: $slug }) {
      seriesTitle
      sermonSeriesDescription {
        sermonSeriesDescription
      }
      sermonSeriesGraphic {
        gatsbyImageData(layout: FULL_WIDTH)
        description
      }
      sermons {
        preacher
        sermonTitle
        sermonDescription {
          sermonDescription
        }
        youTubeLink
        date
      }
    }
  }
`
export const Head = ({ data }) => {
  const { seriesTitle, sermonSeriesDescription } = data.contentfulSermonSeries
  return (
    <Seo
      title={seriesTitle}
      description={sermonSeriesDescription.sermonSeriesDescription}
    />
  )
}
